export default __webpack_public_path__ + "static/media/instagram.dea99669.svg";